// Seed the flat wizard `form` from an existing GetCrude `details[]` row + its
// parent crude. Shared by the Detail page's edit editor (AssayEditorSection,
// editable) and its read-only expanded view (AssayDetailTabs) so both render the
// exact same field layout. Header fields (crudeName/origin/…) come from the
// parent crude so Tab 1's General section isn't blank; assay/yield come from the
// detail row itself.
const mapDetailToForm = (detail, crude) => {
  const d = detail || {};
  const c = crude || {};
  const impls = {};
  (d.implementations || []).forEach(im => {
    impls[im.cduId] = {
      cduId: im.cduId,
      cduName: im.plantName,
      technicalStatus:
        im.technicalStatus === null || im.technicalStatus === undefined
          ? ''
          : String(im.technicalStatus),
      technicalRatio: im.technicalRatio ?? '',
      technicalLimit: im.technicalLimit ?? '',
      implementationStatus: im.implementationStatus ?? '',
      implementationRatio: im.implementationRatio ?? '',
      implementationLimit: im.implementationLimit ?? '',
    };
  });
  return {
    // header (read-only-ish, but shown on Tab 1 General so it's not blank)
    crudeName: c.crudeName ?? '',
    origin: c.origin ?? '',
    country: c.country ?? '',
    codeG5: c.codeG5 ?? '',
    productionRate: c.productionRate ?? '',
    parcelSize: c.parcelSize ?? '',
    penyaluran: c.penyaluran ?? '',
    isBlending: (c.compositions || []).length > 0,
    compositions: (c.compositions || []).map(comp => ({
      crudeText: comp.crudeText,
      composition: comp.composition,
    })),
    // assay
    assaYear: d.assayYear ?? '',
    lab: d.lab ?? '',
    api: d.api ?? '',
    sulfur: d.sulfur ?? '',
    pourPoint: d.pourPoint ?? '',
    tan: d.tan ?? '',
    asphaltene: d.asphaltene ?? '',
    sg: d.sg ?? '',
    salt: d.salt ?? '',
    sw: d.sw ?? '',
    mercury: d.mercury ?? '',
    // yield
    gas: d.gas ?? '',
    lNaphta: d.lNaphta ?? '',
    hNaphta: d.hNaphta ?? '',
    kerosene: d.kerosene ?? '',
    lGasoil: d.lGasoil ?? '',
    hGasoil: d.hGasoil ?? '',
    residu: d.residu ?? '',
    // classifications carried for UpdateDetail (§5 needs classificationYieldBefore)
    classificationYieldBefore:
      d.classificationYieldBefore ?? d.classificationYield ?? null,
    evaluationNote: d.evaluationNote ?? '',
    // Implementation-tab Notes ⇄ BE `description` (same pairing the Create wizard
    // uses on write); without this the Notes textarea renders blank on Detail/Edit.
    implementationNote: d.description ?? '',
    masaBerlaku: d.masaBerlaku ?? null,
    isLatUpdate: !!d.isLastUpdate,
    implementations: impls,
  };
};

export default mapDetailToForm;
